import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import Tooltip from '@omilia/tooltip';

import {
  contextType,
  testSetType,
  testSetsEntriesPaginationOptionsType,
} from 'types';

import {
  getPaginationOptions,
  getTestSetEntriesListCount,
} from 'store/services/testSetEntries/selectors';
import { getTestSetEntriesList } from 'store/services/testSetEntries/actions';

import * as annotationsSelectors from 'store/services/annotations/selectors';

import {
  getContextsAll,
  getSelectedContextFromAll,
  getHasSelectedContextFromAll,
  getIsLoadingAll,
} from 'store/services/contexts/selectors';
import {
  getContextsAll as getContextsAllAction,
  selectContextFromAll,
  deselectContextFromAll,
} from 'store/services/contexts/actions';

import Search from 'components/Search';
import ContextsMenu from 'components/ContextsMenu';
import Button from 'components/Button';
import './style.scss';

export class TestSetHeaderNav extends Component {
  static propTypes = {
    contexts: PropTypes.arrayOf(contextType).isRequired,
    currentContext: contextType.isRequired,
    deselectContext: PropTypes.func.isRequired,
    executeAnnotator: PropTypes.func.isRequired,
    getContexts: PropTypes.func.isRequired,
    getTestSetEntriesList: PropTypes.func.isRequired,
    selectContext: PropTypes.func.isRequired,
    count: PropTypes.number,
    hasSelectedContext: PropTypes.bool,
    isAnnotating: PropTypes.bool,
    isLoadingAll: PropTypes.bool,
    paginationOptions: testSetsEntriesPaginationOptionsType,
    testSets: PropTypes.arrayOf(testSetType),
  };

  state = {
    isActive: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.paginationOptions.value__contains && !this.state.isActive) {
      this.setState({
        isActive: true,
      });
    }
  }

  handleToggleInput = newState => {
    this.setState({
      isActive: newState,
    });
  };

  searchTestSetEntries = searchTerm => {
    this.props.getTestSetEntriesList({
      page: 1,
      value__contains: searchTerm,
    });
  };

  handleClickOutside = () => {
    if (this.props.paginationOptions.value__contains === '') {
      this.setState({
        isActive: false,
      });
    }
  };

  handleGetContexts = searchTerm => {
    this.props.getContexts({
      name__icontains: searchTerm,
    });
  };

  handleExecute = () => this.props.executeAnnotator();

  render() {
    const {
      testSets,
      isAnnotating,
      paginationOptions,
      count,
      contexts,
      currentContext,
      hasSelectedContext,
      isLoadingAll,
      selectContext,
      deselectContext,
    } = this.props;
    /*
    eslint-disable camelcase,
    jsx-a11y/no-static-element-interactions,
    jsx-a11y/click-events-have-key-events
    */
    const { value__contains } = paginationOptions;
    const { isActive } = this.state;

    return (
      <div styleName="header-nav">
        <Search
          getItems={this.searchTestSetEntries}
          isActive={isActive}
          itemsCount={testSets.length}
          placeholder="Search on test set"
          searchTerm={value__contains}
          styleName="header-nav__search"
          onToggleStatus={this.handleToggleInput}
        />

        {!isActive && (
          <div styleName="header-nav__inactive-elements">
            <ContextsMenu
              contexts={contexts}
              currentContext={currentContext}
              deselectContext={deselectContext}
              getContexts={this.handleGetContexts}
              hasSelectedContext={hasSelectedContext}
              isLoading={isLoadingAll}
              selectContext={selectContext}
            />

            <Tooltip content="Run annotator (alt+r)" placement="right">
              <Button
                isSmall
                data-test="button-run-annotations"
                disabled={isAnnotating || !count}
                styleName="run"
                onClick={this.handleExecute}
              >
                Run
              </Button>
            </Tooltip>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  paginationOptions: getPaginationOptions(state),
  count: getTestSetEntriesListCount(state),
  isAnnotating: annotationsSelectors.getIsLoading(state),
  contexts: getContextsAll(state),
  isLoadingAll: getIsLoadingAll(state),
  currentContext: getSelectedContextFromAll(state),
  hasSelectedContext: getHasSelectedContextFromAll(state),
});

const mapDispatchToProps = dispatch => ({
  getTestSetEntriesList: bindActionCreators(getTestSetEntriesList, dispatch),
  getContexts: bindActionCreators(getContextsAllAction, dispatch),
  selectContext: bindActionCreators(selectContextFromAll, dispatch),
  deselectContext: bindActionCreators(deselectContextFromAll, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(onClickOutside(TestSetHeaderNav));
